import React, {Component} from 'react'
import AdminCustomersGrid from './AdminCustomersGrid'
import AdminCustomerProfile from './AdminCustomerProfile'

class AdminCustomers extends Component {
    // constructor() {
    //     super();

    //     this.state = {
    //         id: 0
    //     }
    // }

    // componentDidMount() {
    //     this.setState({
    //         id: this.props.match.params.id
    //     });
    // }
    render() {
        const id = this.props.match.params.id;
        
        if (id) {
            return <AdminCustomerProfile id={id} />
        }

        return <AdminCustomersGrid />
    }
}

export default AdminCustomers


// WEBPACK FOOTER //
// ./src/Components/AdminCustomers/AdminCustomers.js